import { render } from "./WorkItemSmall.vue?vue&type=template&id=37e91e4d"
import script from "./WorkItemSmall.vue?vue&type=script&lang=js"
export * from "./WorkItemSmall.vue?vue&type=script&lang=js"

import "./WorkItemSmall.vue?vue&type=style&index=0&id=37e91e4d&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__